/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStockonhandStocktakeboxCtrl
 */
angular.module('mercury.dialogs.welcome')
.controller('WelcomeDialogCtrl', ["localStorageService", "$scope", "$http", "dialog", "settings", "userinfo", function(localStorageService, $scope, $http, dialog, settings, userinfo) {
  $scope.dontShowAgain = localStorageService.get('dismissFlag.welcomeDialog');
  $scope.bookACallSubmitting = null;
  $scope.bookACallSubmitted = false;
  $scope.bookACallLoading = false;

  $scope.setFlag = function() {
    localStorageService.set('dismissFlag.welcomeDialog', $scope.dontShowAgain);
  };

  $scope.close = function() {
    dialog.close();
  };

  /**
   * Creates a Zendesk ticket with details of the user and company that was just created.
   */
  $scope.bookACall = function() {
    var companyName = userinfo.companyName();
    var email = userinfo.userDetails().email ? userinfo.userDetails().email : 'No Email';
    var name = userinfo.userDetails().name ? userinfo.userDetails().name : 'No Name';

    var requestPayload = {
      email: email,
      page: 'Welcome to Loaded',
      message: name + ' from ' +
        companyName + ' has requested a getting started call after creating their new company. Please contact them at ' +
        email + ' to arrange a time.',
      subject: 'Getting started call request from ' + companyName
    };

    $scope.bookACallLoading = true;
    $scope.bookACallSubmitting = $http.post(settings.mercHost + '/zendesk', requestPayload);
    $scope.bookACallSubmitting.then(function() {
      $scope.bookACallLoading = false;
      $scope.bookACallSubmitted = true;
    });
  };

}]);
